SupportOrderView = require('./order_list_element_view')
SupportStepActionsView = require('../step_actions_view')
SupportHelpWizardController = require('../../helpWizardController')
SupportOrderListViewTemplate = require('../../../order_list_view.html.mustache')
Backbone = require 'backbone'
Backbone.$ = $
SupportStepOneActionsTemplate = require('../../../step_one_actions.html.mustache')

class SupportV2OrderListView extends Backbone.View
  id: 'orderContent'

  events :
    "click #select-current-order"  : "finishChoosingItem"
    "click .orderTableRow td.order-data-cell"  : "clickingItemsTableRow"
    "click .ordersRowError": "handleErrorLinkClick"

  initialize: (options) ->
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @template = SupportOrderListViewTemplate
    @currentChosenItemId = 0
    @currentCheckedRadioBtnSel = 0
    @tableId = '#ordersTable'
    @itemView = SupportOrderView
    @currentOrdersFilter = options.currentOrdersFilter
    @stepActionsView = new SupportStepActionsView
      template: SupportStepOneActionsTemplate
    @itemsPerRow = 2

  render: () ->
    @currentOrdersFilter.iterator.resetIterator()
    @$el.html(toHtml @template, @toHash(), @I18nScope)
    @renderStepActions()
    _scrollLoad = () =>
      $div = $("#ordersTablewrapper", @$el)
      if ( ($div[0].scrollHeight - $div.scrollTop()) <= ($div.height() + 100) )
        return unless @currentOrdersFilter.iterator.hasNext()
        @renderOrders()
    $("#ordersTablewrapper", @$el).scroll(_scrollLoad)
    @renderOrders()
    @delegateEvents()

  toHash: () ->
    isV2: true

  renderItems: (items) ->
    return unless items?.length > 0
    itemsTable = @$el.find(@tableId)
    singletonItemviewObj  = new @itemView
    emptyTds = $('tr.orderTableRow:last-child td.empty-data-cell', itemsTable)
    noOfEmptyTds = emptyTds.length
    index = 0

    while(index < noOfEmptyTds)
      singletonItemviewObj.replaceEmptyTemplateWithOrderTemplate($(emptyTds[index]), items[index])
      index++

    while(index < items.length)
      orders = items.slice(index, index + @itemsPerRow)
      itemviewObj  = new @itemView
      itemviewObj.renderMultipleItems(orders)
      itemsTable.append(itemviewObj.$el)
      index = index + @itemsPerRow

    lastRow = $('tr.orderTableRow:last-child', itemsTable)
    noOfOrderTds = $('td.order-data-cell', lastRow).length
    while(noOfOrderTds > 0 && noOfOrderTds < @itemsPerRow)
      lastRow.append(singletonItemviewObj.renderEmptyTemplate())
      noOfOrderTds++

  finishChoosingItem: (e)->
    if @currentChosenItemId?
      item = Groupon.Support.OrdersCollection.findOrderById(@currentChosenItemId)
      SupportHelpWizardController.stepOne(item) if item?
    return false

  enableSelectOrder: () ->
    if @currentChosenItemId?
      $("#select-current-order", @stepActionsView.el).removeAttr('disabled')

  clickingItemsTableRow: (e) ->
    $td = $(e.currentTarget)
    radioBtn = $td.find('input')
    if @currentCheckedRadioBtnSel.length > 0
      @currentCheckedRadioBtnSel.prop('checked', false)
      $oldTd  =  @currentCheckedRadioBtnSel.closest('td.order-data-cell')
      $oldTd.removeClass('selected')
    @currentCheckedRadioBtnSel = radioBtn
    radioBtn.prop('checked', true)
    $td.addClass('selected')
    @currentChosenItemId = $td.attr('key')
    @enableSelectOrder()
    return true

  handleErrorLinkClick: () ->
    @currentOrdersFilter.iterator.resetState()
    @renderOrders()

  renderOrders: () ->
    return unless @currentOrdersFilter.iterator.hasNext()
    @removeOrdersFetchError()
    @renderSpinner()
    successCb = (orders) =>
      @removeSpinner()
      if orders?.length > 0
        @renderItems(orders)
        @checkIfMinimumOrdersAreShown()
      else
        @renderOrders()
    errCb = () =>
      @removeSpinner()
      @renderOrdersFetchError()
    @currentOrdersFilter.iterator.next(successCb, errCb)

  checkIfMinimumOrdersAreShown : () ->
    return unless @currentOrdersFilter.iterator.hasNext()
    if @currentOrdersFilter.iterator.getNumberOfOrdersFetched() < @currentOrdersFilter.iterator.getNumberOfItemPerPage()
      @renderOrders()

  renderOrdersFetchError: () ->
    @removeOrdersFetchError()
    ordersTable = $(@el).find(@tableId)
    ordersTable.append(@errorHtml())

  errorHtml: () ->
    $ordersRowError = $('.template-table tr.ordersRowErrorSample', @$el).clone()
    $ordersRowError.removeClass('ordersRowErrorSample').addClass('ordersRowError')
    $ordersRowError

  removeOrdersFetchError: () ->
    $('.ordersRowError',  @$el).remove()

  renderSpinner: () ->
    @removeSpinner()
    ordersTable = @$el.find(@tableId)
    ordersTable.append(@spinnerHtml())

  spinnerHtml: () ->
    $div = $("<div></div>")
    showLoading($div, "50px")
    $ordersRowSpinner = $('.template-table tr.ordersRowSpinnerSample', @$el).clone()
    $('.content', $ordersRowSpinner).html($div.html())
    $ordersRowSpinner.removeClass('ordersRowSpinnerSample').addClass('ordersRowSpinner')
    $ordersRowSpinner

  removeSpinner: () ->
    $('.ordersRowSpinner', @$el).remove()

  renderStepActions: ->
    @stepActionsView.render()
    @$el.append(@stepActionsView.el)

  removeView: () ->
    @remove()
    @$el.empty()
    @stepActionsView.remove()
    @stepActionsView.$el.empty()

module.exports = SupportV2OrderListView
